import { RootState } from 'modules'
import { IBot } from 'pages/App/components/Sidebar/SidebarInfo/Bots'

export const selectAppList = (state: RootState): Array<IBot> | null =>
  state.apps.list

export const selectAppFetchedStatus = (state: RootState): boolean =>
  state.apps.fetched
